import {
  CalendarToday,
  CheckCircle,
  CalendarMonth as CalendarIcon,
  CheckCircle as CheckCircleIcon,
  Warning as AlertTriangleIcon,
  Build as WrenchIcon,
  Close as CloseIcon,
  Print as PrinterIcon,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  LinearProgress,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useToast } from "../../../../../Hooks/UseToast";
import moment from "moment/moment";
import axios from "axios";
import { UrlApi } from "../../../../../services/apirest";
import useMatafuegos from "../../../hooks/useMatafuegos";
export const InspeccionPage = ({ plantaId }) => {
  const { showToast, Toast } = useToast();
  const { inspections, fetchMatafuegos, handleItemCheck } = useMatafuegos();
  const [maintenanceDialog, setMaintenanceDialog] = useState({
    open: false,
    extinguisherId: "",
    itemId: "",
    reason: "",
  });
  useEffect(() => {
    fetchMatafuegos(plantaId);
  }, [plantaId]);
  const inspectionItems = [
    {
      key: "cartel",
      label: "Inspección de Cartel",
      description:
        "Verificar que el cartel esté visible, legible y en buen estado",
    },
    {
      key: "caja",
      label: "Estado de la Caja",
      description:
        "Revisar que la caja no tenga daños, corrosión o deformaciones",
    },
    {
      key: "hasfechavto",
      label: "Fecha de Vencimiento",
      description: "Verificar que la fecha de vencimiento esté vigente",
    },
    {
      key: "manguera",
      label: "Estado de la Manguera",
      description:
        "Inspeccionar que la manguera no tenga grietas, cortes o deterioro",
    },
    {
      key: "manometro",
      label: "Manómetro",
      description:
        "Verificar que la presión esté en el rango verde (operativo)",
    },
  ];

  const handleSendToMaintenance = async (extinguisherId, itemId, reason) => {
    if (!reason.trim()) {
      alert(
        "Por favor ingrese la razón por la cual no se pudo completar la inspección"
      );
      return;
    }
    const equipo = inspections.find((ext) => ext.id === extinguisherId);
    const titulo = inspectionItems.find((item) => item.key === itemId)?.label;
    try {
      await axios.post(UrlApi + "/mp_correctivos/", {
        id_equipo: extinguisherId,
        id_planta: equipo.id_planta,
        titulo: titulo,
        tarea: reason,
        preparo: localStorage.getItem("user"),
      });
      showToast("Enviado a mantenimiento correctivos", "success");
    } catch (err) {
      console.log(err);
      showToast("Error al enviar equipo a correctivos", "error");
    }
    setMaintenanceDialog({
      open: false,
      extinguisherId: "",
      itemId: "",
      reason: "",
    });
  };

  const getExtinguisherProgress = (extinguisherId) => {
    // 1. Encontrar el extintor correcto en el array 'inspections'
    // Tu código actual asume que 'inspections' es un objeto, pero lo formateas como un array.
    const extinguisher = inspections.find((ext) => ext.id === extinguisherId);

    // 2. Manejar el caso de que no se encuentre el extintor o no tenga inspección
    // Esto evita errores si el ID no existe o los datos están incompletos.
    if (!extinguisher || !extinguisher.inspeccion) {
      return { completed: 0, total: inspectionItems.length, percentage: 0 };
    }

    // 3. Contar los ítems completados
    // Se mapea sobre 'inspectionItems' y se filtra por los que están en 'true'
    // en la inspección del extintor.
    const completed = inspectionItems.filter(
      (item) => extinguisher.inspeccion[item.key]
    ).length;

    // 4. Calcular el total y el porcentaje
    const total = inspectionItems.length;
    const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

    return { completed, total, percentage };
  };

  console.log("inspecciones", inspections);

  return (
    <Box>
      {Toast}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
        <CalendarToday sx={{ fontSize: "1rem", color: "text.secondary" }} />
        <Typography variant="body2" color="text.secondary">
          Fecha actual: {new Date().toLocaleDateString("es-ES")}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {inspections.length > 0 ? (
          inspections.map((extinguisher) => {
            const progress = getExtinguisherProgress(extinguisher.id);

            return (
              <Card key={extinguisher.id} sx={{ border: "2px solid" }}>
                <CardHeader
                  title={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography variant="h6">
                        {extinguisher.zona} - {extinguisher.sector}
                      </Typography>
                    </Box>
                  }
                  subheader={
                    <Typography variant="body2" color="text.secondary">
                      Número de Serie: {extinguisher.serie_equipo} | Última
                      inspección:{" "}
                      {extinguisher.inspeccion.fecha_inspeccion &&
                        moment(extinguisher.inspeccion.fecha_inspeccion).format(
                          "DD/MM/YYYY"
                        )}{" "}
                      | Tipo: {extinguisher.tipo} | Capacidad (kg):{" "}
                      {extinguisher.capacidad}{" "}
                    </Typography>
                  }
                  action={
                    <Box sx={{ textAlign: "right" }}>
                      <Chip
                        label={`${progress.completed}/${progress.total} (${progress.percentage}%)`}
                        color={
                          progress.percentage === 100 ? "primary" : "default"
                        }
                        sx={{
                          backgroundColor:
                            progress.percentage === 100
                              ? "primary.main"
                              : "grey.300",
                          color:
                            progress.percentage === 100 ? "white" : "black",
                        }}
                      />
                      <LinearProgress
                        variant="determinate"
                        value={progress.percentage}
                        sx={{
                          width: 128,
                          height: 8,
                          mt: 1.5,
                          borderRadius: 4,
                        }}
                      />
                    </Box>
                  }
                />

                <CardContent>
                  <Grid container spacing={4}>
                    <Grid item xs={12} lg={6}>
                      <Typography
                        variant="subtitle1"
                        component="h4"
                        sx={{ fontWeight: "medium", mb: 2 }}
                      >
                        Lista de Verificación
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1.5,
                        }}
                      >
                        {inspectionItems?.map((item) => {
                          // Aseguramos que inspeccion y correctivo existan antes de acceder a ellos.
                          const inspeccion = extinguisher?.inspeccion || {};

                          // 1. Lógica para el estado de "checked"
                          const isChecked = inspeccion[item.key] || false;
                          const isInMaintenance =
                            extinguisher?.correctivo?.titulo === item.label;
                          const estaRealizado =
                            extinguisher?.correctivo?.titulo === item.label &&
                            extinguisher.correctivo.realizado === 0; //condicion para verificar que el correctivo sea el check y que no este realizado
                          return (
                            <Box
                              key={item.key}
                              sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 1.5,
                                p: 1.5,
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 2,
                                "&:hover": {
                                  backgroundColor: "action.hover",
                                },
                                transition: "background-color 0.3s",
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={isChecked} // <-- Usa el valor del estado para el `checked`
                                    onChange={(e) =>
                                      handleItemCheck(
                                        extinguisher.id,
                                        item.key, //guardamos la key (columna de la tabla)
                                        e.target.checked // !extinguisher?.inspeccion?.[item.key] //pasamos el valor contrario al actual (tooggle)
                                      )
                                    }
                                    disabled={estaRealizado}
                                    sx={{ mt: 0.25 }}
                                  />
                                }
                                label={
                                  <Box>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontWeight: "medium",
                                        textDecoration: isChecked
                                          ? "line-through"
                                          : "none",
                                        color: isChecked
                                          ? "text.secondary"
                                          : isInMaintenance
                                          ? "error.main"
                                          : "inherit",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {item.label}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                      sx={{ mt: 0.5 }}
                                    >
                                      {item.description}
                                    </Typography>
                                    {isInMaintenance && (
                                      <Typography
                                        variant="body2"
                                        sx={{
                                          color: "error.main",
                                          mt: 0.5,
                                          fontWeight: "medium",
                                        }}
                                      >
                                        Enviado a mantenimiento correctivo
                                      </Typography>
                                    )}
                                  </Box>
                                }
                              />
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 1,
                                  ml: "auto",
                                }}
                              >
                                {isChecked && (
                                  <CheckCircle
                                    color="success"
                                    sx={{ fontSize: "1rem", mt: 0.5 }}
                                  />
                                )}
                                {!isChecked && !isInMaintenance && (
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    sx={{ minWidth: 24, p: 0.5 }}
                                    onClick={() =>
                                      setMaintenanceDialog({
                                        open: true,
                                        extinguisherId: extinguisher.id,
                                        itemId: item.key,
                                        reason: "",
                                      })
                                    }
                                  >
                                    <WrenchIcon sx={{ fontSize: "1rem" }} />
                                  </Button>
                                )}
                                {isInMaintenance && (
                                  <AlertTriangleIcon
                                    color="warning"
                                    sx={{ fontSize: "1rem", mt: 0.5 }}
                                  />
                                )}
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    </Grid>

                    {/* Mantenimiento Correctivo Items */}
                    <Grid item xs={12} lg={6}>
                      {/*   <Typography
                      variant="subtitle1"
                      component="h4"
                      sx={{ fontWeight: "medium", mb: 2 }}
                    >
                      Observaciones
                    </Typography>
                    <TextField
                      value={inspection?.observations || ""}
                      onChange={(e) =>
                        handleObservationsChange(
                          extinguisher.id,
                          e.target.value
                        )
                      }
                      placeholder="Registre cualquier anomalía o comentario..."
                      multiline
                      minRows={8}
                      fullWidth
                    /> */}

                      {extinguisher?.correctivo?.length > 0 && (
                        <Box sx={{ mt: 2 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{ color: "error.main", mb: 1 }}
                          >
                            Elementos en Mantenimiento:
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                            }}
                          >
                            {extinguisher?.correctivo && (
                              <Box
                                key={0} // O un ID único si lo tienes
                                sx={{
                                  p: 1.5,
                                  borderRadius: 1,
                                  bgcolor: "error.light",
                                  borderLeft: "2px solid",
                                  borderColor: "error.main",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: "medium" }}
                                >
                                  {
                                    inspectionItems.find(
                                      (i) =>
                                        i.label ===
                                        extinguisher.correctivo.titulo
                                    )?.label
                                  }{" "}
                                  :
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {extinguisher.correctivo.tarea}
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      )}
                      {/* Barra de progreso de las inspecciones  */}
                      {progress.percentage === 100 ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            color: "success.main",
                            mt: 2,
                          }}
                        >
                          <CheckCircleIcon sx={{ fontSize: "1rem" }} />
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: "medium" }}
                          >
                            Inspección completa
                          </Typography>
                        </Box>
                      ) : progress.completed > 0 ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            color: "warning.main",
                            mt: 2,
                          }}
                        >
                          <AlertTriangleIcon sx={{ fontSize: "1rem" }} />
                          <Typography variant="body2">
                            Faltan {progress.total - progress.completed}{" "}
                            elementos por verificar
                          </Typography>
                        </Box>
                      ) : null}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            );
          })
        ) : (
          <Typography variant="body2" color="text.secondary">
            No hay inspecciones disponibles.
          </Typography>
        )}
      </Box>

      {/*Dialogo de Mantenimiento Correctivo */}
      <Dialog
        open={maintenanceDialog.open}
        onClose={() =>
          setMaintenanceDialog({ ...maintenanceDialog, open: false })
        }
      >
        <DialogTitle>Enviar a Mantenimiento Correctivo</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Indique la razón por la cual no se pudo completar la inspección de:{" "}
            {
              inspectionItems.find(
                (item) => item.key === maintenanceDialog.itemId
              )?.label
            }
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Razón"
            type="text"
            fullWidth
            variant="outlined"
            multiline
            minRows={4}
            value={maintenanceDialog.reason}
            onChange={(e) =>
              setMaintenanceDialog((prev) => ({
                ...prev,
                reason: e.target.value,
              }))
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setMaintenanceDialog({
                open: false,
                extinguisherId: "",
                itemId: "",
                reason: "",
              })
            }
          >
            Cancelar
          </Button>
          <Button
            onClick={() =>
              handleSendToMaintenance(
                maintenanceDialog.extinguisherId,
                maintenanceDialog.itemId,
                maintenanceDialog.reason
              )
            }
            variant="contained"
          >
            Enviar a Mantenimiento
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
